import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs';
import { PublicFlowMonitor } from '../services/public/public-flow-monitor.service';

export const publicFlowErrorsInterceptor: HttpInterceptorFn = (req, next) => {
  const monitor = inject(PublicFlowMonitor);

  return next(req).pipe(
    tap({
      error: (error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          monitor.requestFailed(req.method, req.urlWithParams, error.status);
        }
      },
    }),
  );
};
